import {
    Children,
    cloneElement,
    isValidElement,
    type ReactElement,
} from 'react';
import { useTheme } from '@mui/material';
import Box from '../Box/Box';
import type { FieldWrapperProps } from './IFieldWrapper';
import { styles } from './styles';

interface ChildVariantProps {
    variant?: 'standard' | 'filled' | 'outlined';
}

const FieldWrapper = ({
    filled = false,
    required = false,
    children,
}: FieldWrapperProps) => {
    const theme = useTheme();

    const onlyChild = Children.only(children);
    const enhanced = isValidElement<ChildVariantProps>(onlyChild)
        ? cloneElement<ChildVariantProps>(
            onlyChild as ReactElement<ChildVariantProps>,
            { variant: 'filled' },
        )
        : onlyChild;

    return <Box sx={styles.wrapper(filled, required, theme)}>{enhanced}</Box>;
};

export default FieldWrapper;
